import type { DropdownSelectOption } from './DropdownSelect'

let unserializableCount = 0

/**
 * A string that changes only when the selected options change (key, value and label), so effects
 * can react to a real change instead of to a new array with the same contents. A value that can't
 * be serialized (e.g. circular) gets a fresh signature every call — the old identity behaviour.
 */
export function getValueSignature(value: DropdownSelectOption | DropdownSelectOption[] | null | undefined): string {
  const options = Array.isArray(value) ? value : value ? [value] : []
  try {
    return JSON.stringify(options.map((option) => [option?.key ?? null, option?.value ?? null, option?.label ?? null]))
  } catch {
    unserializableCount += 1
    return `unserializable:${unserializableCount}`
  }
}
